import { Action, Reducer } from "redux";
import { CompanyState, CompanyTypes, CompanyActionTypes } from "./companyTypes";
import {
	haskeyReducer,
	resetIsolatedReducer,
	updateGetIsolated,
	updateSaveIsolated,
} from "@/main/services/reducerUtils";

export const INITIAL_STATE: CompanyState = {
	company: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	companyAll: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	isolated: {},
};

const companyReducer: Reducer<CompanyState> = (state: CompanyState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as CompanyActionTypes;
	switch (actionTypes.type) {
		case CompanyTypes.GET_COMPANY: {
			const isKeyReducer = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducer) return updateGetIsolated(state, actionTypes);

			return {
				...state,
				company: { ...state.company, isLoading: true },
			};
		}
		case CompanyTypes.GET_COMPANY_ALL:
			return {
				...state,
				companyAll: { ...state.companyAll, isLoading: true },
			};
		case CompanyTypes.SAVE_COMPANY: {
			const isKeyReducerSave = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducerSave) return updateSaveIsolated(state, actionTypes);

			return {
				...state,
				company: {
					...state.company,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		}
		case CompanyTypes.SAVE_COMPANY_ALL:
			return {
				...state,
				companyAll: {
					...state.companyAll,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case CompanyTypes.RESET_REDUCER_COMPANY: {
			const isKeyReducerReset = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducerReset) return resetIsolatedReducer(state, actionTypes);

			return {
				...state,
				company: INITIAL_STATE.company,
			};
		}
		default:
			return state;
	}
};

export default companyReducer;
